/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime';
import { GoogleProtobufValueFromJSON, GoogleProtobufValueToJSON, StreemApiArtifactRoomOutcomeReportEntryFromJSON, StreemApiArtifactRoomOutcomeReportEntryToJSON, } from './';
export function StreemApiCreateRoomOutcomeReportRequestFromJSON(json) {
    return StreemApiCreateRoomOutcomeReportRequestFromJSONTyped(json, false);
}
export function StreemApiCreateRoomOutcomeReportRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'diagnoses': !exists(json, 'diagnoses') ? undefined : (json['diagnoses'].map(StreemApiArtifactRoomOutcomeReportEntryFromJSON)),
        'disposition': !exists(json, 'disposition') ? undefined : StreemApiArtifactRoomOutcomeReportEntryFromJSON(json['disposition']),
        'customFields': !exists(json, 'custom_fields') ? undefined : (mapValues(json['custom_fields'], GoogleProtobufValueFromJSON)),
    };
}
export function StreemApiCreateRoomOutcomeReportRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'diagnoses': value.diagnoses === undefined ? undefined : (value.diagnoses.map(StreemApiArtifactRoomOutcomeReportEntryToJSON)),
        'disposition': StreemApiArtifactRoomOutcomeReportEntryToJSON(value.disposition),
        'custom_fields': value.customFields === undefined ? undefined : (mapValues(value.customFields, GoogleProtobufValueToJSON)),
    };
}
//# sourceMappingURL=StreemApiCreateRoomOutcomeReportRequest.js.map